import React, { useEffect } from 'react';
import { useOutletContext } from "react-router-dom";
import { Divider } from 'antd';
import OTA from '@/assets/video/eSyncOTA.mp4';
import Diagnostics from '@/assets/video/cloudDiagnostics.mp4';
import './index.less';
import { Helmet } from 'react-helmet';

export default function Login() {

  const { onEnterChange } = useOutletContext();

  useEffect(() => {
    onEnterChange(false);
  }, []);

  return (
    <div id="Feature5_0" className="home-page-wrapper content7-wrapper">
      <Helmet>
        <meta charSet="utf-8" />
        <title>爱瑟福信息科技(上海)有限公司-平台演示</title>
      </Helmet>
      <div className="home-page content7 platform-container">
        <div className="title-wrapper">
          <h1 className="title-h1">平台演示</h1>
        </div>

        <div className="content-wrapper">
          <h2 className="platform-title" id="eSyncOTA">eSync OTA平台</h2>
          <div className="video-container">
            <video className="platform-video" controls width="500" controlsList="nodownload noremoteplayback noplaybackrate" disablePictureInPicture>
              <source src={OTA} type="video/mp4" />
            </video>
          </div>
          <div className="text-container">
            <a className="platform-link" href="#">点击跳转登录地址</a>
            <i className="platform-text">请联系我们的商务人员协助您进行登录</i>
          </div>
        </div>
        <Divider plain />
        <div className="content-wrapper">
          <h2 className="platform-title" id="cloudDiagnostics">远程诊断平台</h2>
          <div className="video-container">
            <video className="platform-video" controls width="500" controlsList="nodownload noremoteplayback noplaybackrate" disablePictureInPicture>
              <source src={Diagnostics} type="video/mp4" />
            </video>
          </div>
          <div className="text-container">
            <a className="platform-link" href="#">点击跳转登录地址</a>
            <i className="platform-text">请联系我们的商务人员协助您进行登录</i>
          </div>
        </div>
        <div className="content-wrapper">
          <h2 className="platform-title" id="cloudDiagnostics">车载以太网产品</h2>
          <div className="video-container">
            <video className="platform-video" controls width="500" controlsList="nodownload noremoteplayback noplaybackrate" disablePictureInPicture>
              <source src="" type="video/mp4" />
            </video>
          </div>
          <div className="text-container">
            <a className="platform-link" href="#">点击跳转登录地址</a>
            <i className="platform-text">请联系我们的商务人员协助您进行登录</i>
          </div>
        </div>
      </div>
    </div>
  );
}
